export const getdeggrpreleasestatus = (state = [], action) => {
  switch (action.type) {
    case "GET_UNIVERSITY_DATA_RELEASE":
      return action.payload.data;
    case "CLEAR_UNIVERSITY_DATA_RELEASE":
      return [];
    default:
      return state;
  }
};

export const getExamdateReleaseStatus = (state = [], action) => {
  switch (action.type) {
    case "GET_EXAMDATE_DATA_RELEASE":
      return action.payload.data;
    case "CLEAR_EXAMDATE_DATA_RELEASE":
      return [];
    default:
      return state;
  }
};

export const getDegreeReleaseStatus = (state = [], action) => {
  switch (action.type) {
    case "GET_DEGREE_RESULT_DATA_RELEASE":
      return action.payload.data;
    case "CLEAR_DEGREE_RESULT_DATA_RELEASE":
      return [];
    default:
      return state;
  }
};

export const getSemReleaseStatus = (state = [], action) => {
  switch (action.type) {
    case "GET_SEM_RESULT_DATA_RELEASE":
      return action.payload.data;
    case "CLEAR_SEM_RESULT_DATA_RELEASE":
      return [];
    default:
      return state;
  }
};

export const viewResultReleaseStatus = (state = [], action) => {
  switch (action.type) {
    case "GET_RESULT_RELEASE_STATUS":
      return action.payload || state;
    case "CLEAR_RESULT_RELEASE_STATUS":
      return [];
    default:
      return state;
  }
};

export const saveResultReleaseStatus = (state = null, action) => {
  switch (action.type) {
    case "SAVE_RESULT_RELEASE_SUCCESS":
      return action.payload;
    case "CLEAR_SAVE_RESULT_MESSAGE":
      return null;
    default:
      return state;
  }
};
